/*
 * LIOR · Roo Crew bonus sync · roo-bonus-sync.js
 *
 * Keeps the free bonus lines in the cart in step with the number of Kangaroo tees:
 *   2+ tees  → The First 120 Days: Dad's Bonding Playbook ×1 + LIOR Gift Card $10 ×1
 *   4+ tees  → The Safe Close-Contact Bonding Guide ×1
 * The list comes from snippets/roo-bonus-sync-config.liquid (window.RooBonusSyncConfig.bonuses);
 * the ids below are only the fallback.
 *
 * Rules
 *   - Only manages lines tagged _roo_bonus (added by the Roo Crew widget or by this script).
 *     E-book lines the shopper added some other way are never touched.
 *   - Removes bonus lines the tee count no longer supports. A PDF left in a cart with no tees
 *     would be charged full price; one left below its tier no longer matches the offer.
 *   - Adds missing bonus lines only for carts that came through the widget (a tee line carries
 *     _roo_offer), so carts built on other listings are left alone.
 *   - This script does not price anything; something else must make the bonus lines $0 without
 *     taking the shirts' tier discount away (build record, SB-H). Fail-safe: a _roo_bonus line that
 *     is NOT $0 in the cart is removed and not added back during this visit.
 *     A "free" bonus is never left in the cart at a charge.
 *
 * Install (the Rebuy Smart Cart is on every page, so the script must be too while it matters):
 *   - snippets/roo-crew-offer.liquid loads it on the offer page;
 *   - layout/theme.liquid, just before the closing body tag, loads it on every other page only
 *     while the cart holds a line with _roo_offer or _roo_bonus (zero footprint outside the sale).
 *   Loading it twice is harmless: the second copy exits.
 * Optional override before it: window.RooBonusSyncConfig = { teeProductIds: [...], bonuses: [...] };
 */
(function () {
  'use strict';
  if (window.__rooBonusSync) return;

  var cfg = window.RooBonusSyncConfig || {};
  // Every Kangaroo Pocket T-Shirt listing the tier discounts count as shirts, led by the
  // Halloween offer listing (15397349982453, "Kangaroo Pocket T-Shirt Halloween Sale") and the
  // Deal Days offer listing (15399621755125, "Kangaroo Pocket T-Shirt Deal Days Sale", added 2026-10-01).
  // Same list as the "Roo Crew bonus" discount function (its roo_crew.config metafield since 2026-10-01).
  var TEES = cfg.teeProductIds || [
    15397349982453, 15399621755125,
    9052197519605, 9422820442357, 9537952776437, 9570396307701,
    9574560792821, 9576472805621, 9590547939573
  ];
  var BONUSES = cfg.bonuses || [
    { variantId: 47892116111605, from: 2 }, // The First 120 Days: Dad's Bonding Playbook
    { variantId: 47082748838133, from: 2 }, // LIOR Gift Card $10 (USD)
    { variantId: 47892116078837, from: 4 }  // The Safe Close-Contact Bonding Guide
  ];

  var running = false, queued = false, timer = null;

  // Bonuses found charged during this visit (see the fail-safe above). Kept per browser tab.
  var BLOCK_KEY = 'roo_bonus_blocked';
  var blocked = {};
  try { blocked = JSON.parse(window.sessionStorage.getItem(BLOCK_KEY) || '{}') || {}; } catch (e) { blocked = {}; }
  function remember(ids) {
    ids.forEach(function (id) { blocked[id] = true; });
    try { window.sessionStorage.setItem(BLOCK_KEY, JSON.stringify(blocked)); } catch (e) { /* private mode */ }
    if (window.console) console.warn('[roo-bonus-sync] a free bonus line was not $0, so it was removed (build record SB-H).', ids);
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function request(path, body) {
    return fetch(root() + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: body
        ? { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (res) {
      if (!res.ok) throw new Error(path + ' → ' + res.status);
      return res.json();
    });
  }

  // Pure function: what has to change in this cart. No side effects.
  // `skip` = bonus variant ids that must not be added (found charged earlier this visit).
  function plan(cart, skip) {
    skip = skip || {};
    var tees = 0, fromWidget = false, bonusLines = {};
    (cart && cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      if (props._roo_bonus) {
        (bonusLines[item.variant_id] = bonusLines[item.variant_id] || []).push(item);
        return;
      }
      if (TEES.indexOf(item.product_id) !== -1) {
        tees += item.quantity;
        if (props._roo_offer) fromWidget = true;
      }
    });

    var updates = {}, adds = [], block = [], changed = false, recheck = false;
    BONUSES.forEach(function (bonus) {
      var want = tees >= bonus.from ? 1 : 0, have = 0;
      (bonusLines[bonus.variantId] || []).forEach(function (line) {
        var keep = Math.max(0, Math.min(line.quantity, want - have));
        // Still charged at the quantity we would keep = the discount that makes it free isn't
        // live: take it out. (A line above its tier quantity is trimmed first and checked again.)
        var charged = keep > 0 && keep === line.quantity && line.final_line_price > 0;
        if (charged) { keep = 0; if (block.indexOf(bonus.variantId) === -1) block.push(bonus.variantId); }
        if (keep !== line.quantity) { updates[line.key] = keep; changed = true; if (keep > 0) recheck = true; }
        have += keep;
      });
      var skipped = skip[bonus.variantId] || block.indexOf(bonus.variantId) !== -1;
      if (have < want && fromWidget && !skipped) {
        adds.push({ id: bonus.variantId, quantity: want - have, properties: { _roo_bonus: '1' } });
        changed = true;
      }
    });
    return { tees: tees, updates: updates, adds: adds, block: block, changed: changed, recheck: recheck };
  }

  function apply(p) {
    var chain = Promise.resolve();
    if (Object.keys(p.updates).length) {
      chain = chain.then(function () { return request('cart/update.js', { updates: p.updates }); });
    }
    if (p.adds.length) {
      chain = chain.then(function () { return request('cart/add.js', { items: p.adds }); });
    }
    return chain;
  }

  function refreshUI(p) {
    // Rebuy Smart Cart re-reads the Shopify cart; the theme can listen for roo:bonus-sync.
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchShopifyCart === 'function') {
        window.Rebuy.Cart.fetchShopifyCart(function () {});
      }
    } catch (e) { /* Rebuy not ready */ }
    try { document.dispatchEvent(new CustomEvent('roo:bonus-sync', { detail: p })); } catch (e) { /* old browsers */ }
    // The /cart page renders server-side: reload once so it shows the corrected lines.
    if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  }

  function sync() {
    if (running) { queued = true; return Promise.resolve(); }
    running = true;
    var result = null;
    return request('cart.js')
      .then(function (cart) {
        var p = plan(cart, blocked);
        if (p.block.length) remember(p.block);
        if (!p.changed) return;
        result = p;
        return apply(p);
      })
      .then(function () { if (result) refreshUI(result); })
      .catch(function (err) { if (window.console) console.warn('[roo-bonus-sync]', err); })
      .then(function () {
        running = false;
        if (result && result.recheck) queued = true; // a trimmed line gets its price checked again
        if (queued) { queued = false; return sync(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 150);
  }

  [
    'rebuy:cart.change',
    'rebuy:smartcart.line-item-increase',
    'rebuy:smartcart.line-item-decrease',
    'rebuy:smartcart.line-item-removed',
    'roo:added'
  ].forEach(function (name) { document.addEventListener(name, schedule); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  window.__rooBonusSync = { sync: sync, plan: plan };
})();
